import Global from "@/scripts/Global"
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'ConfirmCancelUpload',
    data() {
        return {
            currData: {
                'upload_name': '',
                'upload_id': ''
            },
            confirmCheck: false,
        }
    },
    mounted() {
        this.currData = this.$parent.data
    },
    methods: {
        CancelUpload() {
            Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, this.currData.upload_id)
            Global.globalValue(VueSignals.SET_UPLOAD_CANCELD, this.currData.upload_id)
            Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
        }
    }
}
